<script lang="ts" setup>
	defineOptions({inheritAttrs: false})
</script>

<template>
	<ClientOnly>
		<template #fallback>
			<slot name="fallback" />
		</template>
		<LazyVisibleGsLmapContainer v-bind="$attrs" hydrate-on-visible>
			<template #default><slot name="default" /></template>
		</LazyVisibleGsLmapContainer>
	</ClientOnly>
</template>
